import {INDRABookedTripDetails} from '@ibe.models/booked-trip-details.indra.model.lib';

export interface State {
	loading: boolean;
	bookedTrip: INDRABookedTripDetails;
	documentTypes: any;
	frequentFlyerPrograms: any;
	formChanges: { [key: string]: boolean; };
	notif: any;
}

export const initialState: State = {
	loading: false,
	bookedTrip: null,
	documentTypes: null,
	frequentFlyerPrograms: null,
	formChanges: {},
	notif: {
		icon: '',
		title: 'TAP',
		message: [],
		style: 'alert',
		show: false
	}
};
